import offlineDevicesBySiteModal from './offline-devices-by-site-modal.connect'

export default offlineDevicesBySiteModal
